var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('SimProJobsList',{attrs:{"product":_vm.feedProduct,"siteId":_vm.feedProduct.siteId},on:{"jobsExist":_vm.emitJobsExist}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }